import React, { useEffect, useState } from 'react';
import { IMFormModal, IMInputText, OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { RequestDocumentModalStore } from 'store/modules/upload-documents/ui-stores/requestDocumentModalStore';
import { IMTextAreaStyled } from './styles';
import {
  REQUEST_DOCUMENT_DESCRIPTION_TEST_ID,
  REQUEST_DOCUMENT_FORM_ID,
  REQUEST_DOCUMENT_MODAL_TEST_ID,
  REQUEST_DOCUMENT_NAME_TEST_ID,
  REQUEST_DOCUMENT_SPINNER_TEST_ID,
} from '../constants';
import AddTemplateSection from '../AddTemplateSection';

interface Props {
  show: boolean;
  onClose: () => void;
  modalStore: RequestDocumentModalStore;
}

const RequestDocumentModal: React.FC<Props> = observer(({ show, onClose, modalStore }) => {
  const { form, isLoading, setFile, requestDocumentAction, resetModal } = modalStore;

  const [shouldCollapseOnClose, setShouldCollapseOnClose] = useState(false);
  const [shouldResetUploadedFile, setShouldResetUploadedFile] = useState(false);

  useEffect(() => {
    setShouldCollapseOnClose(false);
    setShouldResetUploadedFile(false);
  }, [show]);

  const onSubmit = async (): Promise<void> => {
    await requestDocumentAction();
    resetModal();
    setShouldCollapseOnClose(true);
    setShouldResetUploadedFile(true);
    onClose();
  };

  function handleClose(): void {
    onClose();
    resetModal();
    setShouldCollapseOnClose(true);
    setShouldResetUploadedFile(true);
  }

  return (
    <IMFormModal
      show={show}
      onClose={handleClose}
      title="Request Document"
      subtitle="Enter the name of the required document and, if needed, a template link. Users will need to provide this document later to complete the step."
      modalType={ModalType.CREATION}
      formController={form}
      formContent={
        <>
          <IMInputText
            label="Document Name"
            name="docName"
            maxLength={30}
            $size="full"
            data-test-id={REQUEST_DOCUMENT_NAME_TEST_ID}
          />
          <IMTextAreaStyled
            label="Description"
            maxLength={500}
            name="description"
            $size="full"
            data-test-id={REQUEST_DOCUMENT_DESCRIPTION_TEST_ID}
          />
          <AddTemplateSection
            setFile={setFile}
            shouldCollapseOnClose={shouldCollapseOnClose}
            shouldResetUploadedFile={shouldResetUploadedFile}
            formId={REQUEST_DOCUMENT_FORM_ID}
          />
          <OverlaySpinner display={isLoading} data-test-id={REQUEST_DOCUMENT_SPINNER_TEST_ID} />
        </>
      }
      closeButtonText="Cancel"
      submitButtonText="Add"
      onSubmit={onSubmit}
      data-test-id={REQUEST_DOCUMENT_MODAL_TEST_ID}
      formId={REQUEST_DOCUMENT_FORM_ID}
    />
  );
});

export default RequestDocumentModal;
